import { render, staticRenderFns } from "./NoPlasticCard.vue?vue&type=template&id=af9350cc&"
import script from "./NoPlasticCard.vue?vue&type=script&lang=js&"
export * from "./NoPlasticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports